import { merchatlogin, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken, removeLocalStorage ,removeSessionStorage, getCookies, setCookies,removeCookies } from '@/utils/auth'
import { resetRouter } from '@/router'


// 刷新会丢失？
let getDefaultState = () => {
  let orgToken = getCookies('orgToken')
  return {
    token: () => {
      return orgToken ? '' : getToken()
    },
    orgToken: () => {
      return orgToken ? getToken() : ''
    }
  }
}

const state = getDefaultState()

const mutations = { // store的set方法
  RESET_STATE: (state, token) => {
    // Object.assign(state, getDefaultState())
    Object.assign(state, token)
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ORGTOKEN: (state, token) => {
    state.orgToken = token
  },

  // SET_NAME: (state, name) => {
  //   state.name = name
  // },
  // SET_AVATAR: (state, avatar) => {
  //   state.avatar = avatar
  // },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      merchatlogin(userInfo).then(res => {
        let data = res.data
        console.log(data);
        if (data) {
          setToken(data.accessToken)
          commit('SET_TOKEN', data.accessToken)
          commit('SET_ORGTOKEN', '')
          //移除机构登录权限信息
          // setSessionStorage('userInfo', {}  )
          removeSessionStorage('orgAuthInfo')
          setCookies("expiresIn", data.expiresIn)
          removeCookies('orgToken');
          // sessionStorage.setItem('name', data.realName)
          resolve(res)
        } else {
          resolve(res)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },



  // // get user info
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token).then(response => {
  //       const { data } = response
  //       if (!data) {
  //         return reject('Verification failed, please Login again.')
  //       }

  //       const { name, avatar } = data

  //       commit('SET_NAME', name)
  //       commit('SET_AVATAR', avatar)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // user logout
  // logout({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     logout(state.token).then(() => {
  //       removeToken() // must remove  token  first
  //       resetRouter()
  //       commit('RESET_STATE')
  //       resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  logout({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      // resetRouter()
      commit('SET_TOKEN', '')
      commit('SET_ORGTOKEN', '')
      removeCookies('token')
      removeCookies('orgToken');
      removeCookies('expiresIn');
      removeSessionStorage('userInfo')
      removeSessionStorage('orgAuthInfo')
      sessionStorage.removeItem("store")
      resolve()
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

